export default __webpack_public_path__ + "static/media/Save.9005710b.svg";